export const DEVELOPMENT_FLAGS_KEY = 'DEVELOPMENT_FLAGS';
